import * as React from 'react';
import * as styles from './N1PublicationBannerMobile.css';
import { IN1PublicationBannerProps } from '../../types';
import n1Logo from '../../images/n1_logo.png';

export const N1PublicationBannerMobile = (props: IN1PublicationBannerProps) => {
  const { handleCloseClick } = props;

  return (
    <div className={styles['wrapper']}>
      <div className={styles['close']} onClick={handleCloseClick}>
        ×
      </div>

      <div className={styles['left']}>
        <div className={styles['title']}>Два сервиса по&nbsp;цене одного</div>
        <div className={styles['text']}>
          Объявления, размещённые на&nbsp;Циан, автоматически публикуются на&nbsp;N1.RU, не&nbsp;теряя продвижения
        </div>
      </div>

      <div>
        <img src={n1Logo} width="80" height="80" />
      </div>
    </div>
  );
};
